module.exports = __webpack_public_path__ + "img/stage-make-decision.48c5a8ff.svg";